export default __webpack_public_path__ + "static/media/image2.0baca77f.png";